import { AxiosResponse } from "axios";
import React from "react";
import MultiPickerListWithSelectedItems from "../MultiPickerListWithSelectedItems";
import { MultiPickerListProps } from "../props";
import { LinkedWordTemplatePanelInstructionBase } from "./model";
import CultureFlag from "components/Culture/CultureFlag";

interface Props<T extends LinkedWordTemplatePanelInstructionBase> extends MultiPickerListProps<server.dto.WordTemplate> {
  initialInstruction: T;
  listFunc: (instruction: T) => Promise<AxiosResponse<server.dto.ApiResponseWrapperWithRequest<server.dto.WordTemplate[], server.dto.ListLinkedWordTemplateFilters>, any>>;
}

const MultiLinkedWordTemplateList = <T extends LinkedWordTemplatePanelInstructionBase>(props: Props<T>) => {
  const [instruction, setInstruction] = React.useState<T>({
    page: 1,
    perPage: 20,
    keyword: undefined,
    ...props.initialInstruction,
  });

  return <>
    <MultiPickerListWithSelectedItems
      instruction={instruction}
      onInstructionChange={i => setInstruction(i)}
      queryKey="linkedwordtemplatepickerlist"
      api={props.listFunc}

      getError={() => undefined}
      excludeKeys={props.excludeKeys}

      onChange={props.onChange}
      renderListItem={wordTemplate => <div className="flex gap-small align-center">
        <CultureFlag lcid={wordTemplate.lcid} />
        {wordTemplate.title}
      </div>}
      getId={wt => wt.wordTemplateId}
      getLabel={wordTemplate => <div>{wordTemplate.title}</div>}
      value={props.value}
    />
  </>;
};

export default MultiLinkedWordTemplateList;